// Central contact details for CJ's Mobile Detailing.
export const PHONE_DISPLAY = "0439086218";
export const PHONE_TEL = "tel:+61439086218";
export const PHONE_SMS = "sms:+61439086218";
